import { getPath } from '@/router/common'

const baseUrl = {
  title: '加载页',
  path: 'loadpage'
}

export default [
  {
    path: getPath('index', baseUrl),
    name: 'loadpage_index',
    component: () => import(/* webpackChunkName: "loadpage_index" */ '@/views/loadpage/index.vue'),
    meta: {
      title: '加载页'
    }
  },
]
